import React from "react";
import CampaignSharedHeader from "./CampaignSharedHeader";
import CampaignStatGrid from "./CampaignStatGrid";
import { CampaignHeaderProps, CampaignStat } from "../../interface/shared";
import { CurrencyCode } from "../../../../shared/constants";
import { cn } from "../../../../lib/utils";

interface BaseCampaignDetailProps {
  headerProps: CampaignHeaderProps;
  stats?: CampaignStat[];
  currency?: CurrencyCode;
  chart?: React.ReactNode;
  sidebar?: React.ReactNode;
  children?: React.ReactNode; // Extra content if needed
  statsCounts?: number
}

const BaseCampaignDetail: React.FC<BaseCampaignDetailProps> = ({
  headerProps,
  stats,
  currency,
  chart,
  sidebar,
  children,
  statsCounts
}) => {
  const displayCols = statsCounts || stats?.length || 4;
  return (
    <div className="flex flex-col gap-2 bg-slate-50/30">
      <CampaignSharedHeader {...headerProps} />

      {stats && stats.length > 0 && (
        <CampaignStatGrid stats={stats} columns={displayCols} currency={currency} />
      )}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-2">
        {/* Main Content (Chart) */}
        <div className={cn(
          "flex flex-col gap-6",
          sidebar ? "lg:col-span-8" : "lg:col-span-12"
        )}>
          {chart && (
            <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
              {chart}
            </div>
          )}
          {children}
        </div>

        {/* Sidebar (Settings) */}
        {sidebar && (
          <div className="lg:col-span-4">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 sticky top-6">
              {sidebar}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BaseCampaignDetail;
